import React from "react";

interface IProps {
  theme: "light" | "dark";
}

export const EmptyCircle = ({ theme }: IProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 8.5C0.5 4.35786 3.85786 1 8 1C12.1421 1 15.5 4.35786 15.5 8.5C15.5 12.6421 12.1421 16 8 16C3.85786 16 0.5 12.6421 0.5 8.5Z"
        fill={theme === "light" ? "#FFF" : "#1C1F23"}
      />
      <path
        d="M0.5 8.5C0.5 4.35786 3.85786 1 8 1C12.1421 1 15.5 4.35786 15.5 8.5C15.5 12.6421 12.1421 16 8 16C3.85786 16 0.5 12.6421 0.5 8.5Z"
        stroke="#C0C0C0"
      />
    </svg>
  );
};
